import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { HttpClientModule, HttpHeaders } from '@angular/common/http';
import { InMemoryCache } from '@apollo/client/core';
import { environment } from '../environments/environment';
import { APP_BASE_HREF } from '@angular/common';
import { FloatingButtonComponent } from './floating-button/floating-button.component';
import { PopupBoxComponent } from './popup-box/popup-box.component';

@NgModule({
  declarations: [
    AppComponent,
    FloatingButtonComponent,
    PopupBoxComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ApolloModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory(httpLink: HttpLink) {
        const isServerRender = typeof window === 'undefined';
        const uri = isServerRender ? environment.pollInternalApi : environment.pollApi;

        return {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: uri,
            headers: new HttpHeaders().set('Cache-Control', 'max-age=31536000')

          }),
        };
      },
      deps: [HttpLink],
    },
    {
      provide: APP_BASE_HREF,
      useValue: "",
    },
  ], bootstrap: [AppComponent],
})
export class AppModule { }
